const UNOPENED_QUEUE_EVENT = 'ots:unopened-queue-refresh';

export function notifyUnopenedQueueChanged(): void {
  window.dispatchEvent(new Event(UNOPENED_QUEUE_EVENT));
}

export function onUnopenedQueueChanged(handler: () => void): () => void {
  window.addEventListener(UNOPENED_QUEUE_EVENT, handler);
  return () => window.removeEventListener(UNOPENED_QUEUE_EVENT, handler);
}
